// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__7e+ak","title":"style_title__U7Nh4","text":"style_text__5lzR0"};